/* Lovy Studios — sticky add-to-cart tweaks, zie snippets/lovy-sticky-atc.liquid */
(function () {
    function getSelects() {
      return Array.prototype.slice.call(document.querySelectorAll('variant-picker select'));
    }
    function getSizeSelect() {
      var selects = getSelects();
      for (var i = 0; i < selects.length; i++) {
        var m = selects[i].name.match(/^options\[(.+)\]$/);
        if (m && /^(size|maat|shoe ?size)$/i.test(m[1])) return selects[i];
      }
      return null;
    }
    function inject(sticky) {
      var bar = sticky.querySelector('.sticky-add-to-cart__bar');
      var sizeSelect = getSizeSelect();
      if (!bar || !sizeSelect || bar.querySelector('.lovy-sticky-size')) return;
      var variantEl = bar.querySelector('.sticky-add-to-cart__variant');
      if (!variantEl) return;
      var mini = document.createElement('select');
      mini.className = 'lovy-sticky-size';
      mini.setAttribute('aria-label', 'Maat');
      for (var i = 0; i < sizeSelect.options.length; i++) {
        var o = sizeSelect.options[i];
        var opt = new Option(o.textContent.trim(), o.value);
        opt.disabled = o.disabled;
        mini.add(opt);
      }
      mini.value = sizeSelect.value;
      mini.addEventListener('change', function () {
        var live = getSizeSelect();
        if (!live) return;
        live.value = mini.value;
        live.dispatchEvent(new Event('change', { bubbles: true }));
      });
      var rest = getSelects()
        .filter(function (s) { return s !== sizeSelect; })
        .map(function (s) { return s.value; })
        .join(' / ');
      variantEl.replaceChildren(mini);
      if (rest) {
        var span = document.createElement('span');
        span.className = 'lovy-sticky-size-rest';
        span.textContent = rest;
        variantEl.appendChild(span);
      }
    }
    function init() {
      var sticky = document.querySelector('sticky-add-to-cart');
      if (!sticky) return;

      if (getSizeSelect()) {
        inject(sticky);
        new MutationObserver(function () { inject(sticky); }).observe(sticky, { childList: true, subtree: true });
      }

      // Balk zichtbaar houden tot de onderkant van de pagina.
      // Zelfde zichtbaarheidsregel als het thema (koopknop voorbij gescrold),
      // maar zonder de footer-verberging.
      //
      // ALLEEN MOBIEL (R1, 21 sep 2026). Op desktop is de balk sinds deze
      // draft ook zichtbaar, en daar dekte hij de HK-bedrijfsgegevens en de
      // policy-links in de footer af. Vanaf 750 px laten we de
      // footer-verberging van het thema dus gewoon zijn werk doen.
      var alleenMobiel = window.matchMedia('(max-width: 749px)');
      var ticking = false;
      function fixStuck() {
        ticking = false;
        if (!alleenMobiel.matches) return;
        var bar = sticky.querySelector('.sticky-add-to-cart__bar');
        var buy = document.querySelector('.buy-buttons-block');
        if (!bar || !buy) return;
        var r = buy.getBoundingClientRect();
        var gewenst = (r.bottom < 0 || r.top < 0) ? 'true' : 'false';
        if (bar.dataset.stuck !== gewenst) bar.dataset.stuck = gewenst;
      }
      document.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(fixStuck); }
      }, { passive: true });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
